import { render, staticRenderFns } from "./suspendedRoute.vue?vue&type=template&id=4f92b36c&scoped=true&"
import script from "./suspendedRoute.vue?vue&type=script&setup=true&lang=js&"
export * from "./suspendedRoute.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f92b36c",
  null
  
)

export default component.exports